import { Stack, Text, Textarea } from "@mantine/core";

import type { Composer } from "../composer/use-composer";

/** Live's placeholder for the negative prompt, its ⊖ included. */
const PLACEHOLDER =
  "⊖ blurry, low resolution, pixelated, jpeg artifacts, text, watermark, signature";

/**
 * Live's negative prompt (#231, `negative-prompt-textarea`): under the prompt while its switch
 * is on, one to four rows, with its own counter to the block's cap (the prompt's where the block
 * names none).
 */
export function NegativePrompt({ c }: { c: Composer }) {
  const caps = c.advancedCaps?.negative_prompt;
  if (caps === null || caps === undefined || !c.draft.advanced.negative) return null;
  const max = caps.max_chars ?? c.promptMax;
  const text = c.draft.advanced.negativeText;
  return (
    <Stack gap={4}>
      <Textarea
        variant="unstyled"
        aria-label="Negative prompt text"
        placeholder={PLACEHOLDER}
        autosize
        minRows={1}
        maxRows={4}
        maxLength={max}
        value={text}
        onChange={(event) => c.setAdvanced({ negativeText: event.currentTarget.value })}
      />
      <Text size="xs" c="var(--cai-color-text-muted)" ta="right">
        {text.length} / {max}
      </Text>
    </Stack>
  );
}
